import { createSelector } from 'reselect';
import { purposesToEnableConfigPrinterSetting } from '../consts';

const getDevice = (state) => state.device;

export const devicesSelector = createSelector(
  (state) => state.device.isLoadingDevices,
  (state) => state.device.devices,
  (isLoading, devices) => ({ isLoading, devices })
);

export const printersSelector = createSelector(
  (state) => state.device.isLoadingPrinters,
  (state) => state.device.printers,
  (isLoading, printers) => {
    let enabledPrinters = [];

    if (printers.length) {
      enabledPrinters = printers.filter(
        (printer) =>
          !!(printer.printer_settings || []).find((setting) =>
            purposesToEnableConfigPrinterSetting.includes(setting.purpose)
          )
      );
    }

    return {
      isLoading,
      printers,
      enableConfigMappingPrinters: enabledPrinters,
    };
  }
);

export const isUpdatingDeviceSelector = createSelector(getDevice, (device) => device.isUpdatingDevice);

export const isDeletingDeviceSelector = createSelector(getDevice, (device) => device.isDeletingDevice);
